const maskData = [
    {
        id:"1",
        name:"B complex inj",
    },
    {
        id:"2",
        name:"Stored at room temperature ",
    },
    {
        id:"3",
        name:"Protected from light",
    },
    {
        id:"4",
        name:"Given IV/IM",
    },
    {
        id:"5",
        name:"Support nerve function",
    },
    // {
    //     id:"6",
    //     name:"Mud Mask with Green Tea",
    // },
    // {
    //     id:"7",
    //     name:"Mud Mask with Carrot",
    // },
    // {
    //     id:"8",
    //     name:"Mud Mask with Revitalizing Ingredients (Calendula flower)",
    // },
]

export default maskData;